module.exports = __webpack_public_path__ + "img/oufu_120x140x12.prt.f3468551.jpg";